const translations = {
  "en": {
    "No search results": "No search results",
    "Search themes...": "Search themes..."
  },
  "zh-tw": {
    "No search results": "沒有搜尋結果",
    "Search themes...": "搜尋主題..."
  }
};

export default translations;
